import { render } from "./hris-category-and-groups.vue?vue&type=template&id=243448b7&lang=pug"
import script from "./hris-category-and-groups.vue?vue&type=script&lang=js"
export * from "./hris-category-and-groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__